export default __webpack_public_path__ + "static/media/bg-titre-header-bleu.60766b4e.webp";